// extracted by mini-css-extract-plugin
export default {"linkWrapper":"_2DOkg","avatar":"_1pCk6","textName":"_1bG43","textProfileAdditionalInfo":"_3xYnK","textUnderline":"hivc6"};